import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import Swal from 'sweetalert2';

const Login = () => {
	const { isDark, toggleTheme } = useTheme();
	const { login } = useAuth();
	const navigate = useNavigate();
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [error, setError] = useState('');

	const handleSubmit = async e => {
		e.preventDefault();
		setError('');
		const ok = await login(email.trim(), password);
		if (ok) {
			navigate('/dashboard');
		} else {
			Swal.fire({
				icon: 'error',
				title: 'Oops...!',
				text: 'Invalid credentials',
				timer: 2000,
				showConfirmButton: false
			});
			// setError('Invalid credentials');
		}
	};

	return (
    <div className={`min-h-screen flex items-center justify-center ${
            isDark ? 'bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-blue-900 via-indigo-900 to-indigo-950' : 'bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-blue-100 via-indigo-100 to-white'
            }`}>
			<button
				className={`absolute top-4 right-4 rounded-full px-3 py-1 text-sm ${
					isDark ? 'bg-white/10 text-indigo-100' : 'bg-white text-indigo-700 shadow'
				}`}
				onClick={toggleTheme}
			>
				{isDark ? 'Dark' : 'Light'}
			</button>
			<div className={`w-full max-w-md rounded-2xl overflow-hidden shadow-2xl ${
				isDark ? 'bg-white/10 backdrop-blur text-indigo-100' : 'bg-white text-indigo-900'
			}`}>
				<div className={`p-6 text-center ${isDark ? 'bg-gradient-to-r from-indigo-800 to-blue-700' : 'bg-gradient-to-r from-indigo-600 to-blue-500'} text-white`}>
					<h1 className="text-2xl font-extrabold tracking-wide">RCCG The Throne Room</h1>
					<p className="text-xs mt-1 opacity-90">Reset & Overflows</p>
				</div>
				<form onSubmit={handleSubmit} className="p-6 space-y-4">
					<div>
						<label className="block text-sm mb-1">Email</label>
						<input
							type="email"
							value={email}
							onChange={e => setEmail(e.target.value)}
							className={`w-full p-3 rounded-xl border focus:outline-none focus:ring-2 ${
								isDark
									? 'bg-white/5 border-white/20 text-indigo-100 focus:ring-indigo-300'
									: 'bg-white border-indigo-200 focus:ring-indigo-400'
							}`}
							placeholder="you@example.com"
							required
						/>
					</div>
					<div>
						<label className="block text-sm mb-1">Password</label>
						<input
							type="password"
							value={password}
							onChange={e => setPassword(e.target.value)}
							className={`w-full p-3 rounded-xl border focus:outline-none focus:ring-2 ${
								isDark
									? 'bg-white/5 border-white/20 text-indigo-100 focus:ring-indigo-300'
									: 'bg-white border-indigo-200 focus:ring-indigo-400'
							}`}
							placeholder="••••••••"
							autoComplete="current-password"
							required
						/>
					</div>
					{error && <p className="text-red-500 text-sm">{error}</p>}
					<button
						type="submit"
						className={`w-full py-3 rounded-xl font-semibold transition ${
							isDark
								? 'bg-gradient-to-r from-indigo-700 to-blue-600 hover:brightness-110'
								: 'bg-gradient-to-r from-indigo-600 to-blue-500 text-white hover:opacity-95'
						}`}
					>
						Login
					</button>
					<p className="text-s text-center opacity-70">Developed by <a href="https://www.Royalefootprintsgroup.com" target="_blank" rel="noopener noreferrer" className="text-orange-400 hover:text-orange-400 hover:underline">Royalefootprintsgroup</a></p>
				</form>
			</div>
		</div>
	);
};

export default Login;


